import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  RelatedOffersQueryQueryVariables,
  RelatedOffersQueryQuery
} from "../../../schemaTypes";
import { newOfferSubscription } from "../../Offer/FindOffers";

export const relatedOffersQuery = gql`
  query RelatedOffersQuery(
    $communityId: String!
    $limit: Int!
    $offset: Int!
  ) {
    relatedOffers(
      communityId: $communityId
      limit: $limit
      offset: $offset
    ) {
      id
      title
      description
      bannerUrl
      category {
        id
        name
        imgSrc
        createdBy{
          id
          role
        }
        createdAt
        updatedAt
      }
      offerType
      discountType
      discountValue
      partnerVoucher
      referralUrl
      status
      usageLimitPerUser
      totalUsageLimit
      startDate
      endDate
      community{
        id
        name
        alias
      }
      location{
        id
        city
        district
        streetName
        country
        postalCode
        landmark
        latitude
        longitude
        createdAt
      }
      redemptions
      revenueGenerated
      clickThroughs
      featured
      createdBy{
        id
        role
        admin {
          id
          shortId
          firstname
          lastname
          email
          phone
          merchantProfile {
            id
            businessName
            businessType
            regCountry
            businessRegNumber
            taxId
            address
            addressAlt
            city
            country
            postcode
            companyName
            username
            industry {
              id
              name
              createdBy{
                id
                role
              }
              createdAt
              updatedAt
            }
            companyLocation
            logoUrl
            bannerUrl
            description
            commissionRate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      # njoyCode {
      #   id
      #   code
      #   redeemedAt
      #   createdAt
      #   updatedAt
      # }
      createdAt
      updatedAt
    }
  }
`;

export function useRelatedOffers(variables: RelatedOffersQueryQueryVariables) {
  const { data, loading, subscribeToMore } = useQuery<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>(
    relatedOffersQuery,
    { variables }
  );

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newOfferSubscription,
      variables: { communityId: variables.communityId },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          relatedOffers: [
            ...(prev.relatedOffers || []),
            (subscriptionData.data as any).newOffer
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore, variables.communityId]);

  return {
    relatedOffers: data?.relatedOffers ?? [],
    loading
  };
}